import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Transforming Your Visions into Reality.
          </h1>
          <p className="hero-subtitle">
            Innovate Your Brand with Creative Excellence. Let's Shape Your Digital Journey.
          </p>
          <a href="https://api.whatsapp.com/send?phone=9709072209" target="_blank" rel="noopener noreferrer" className="hero-cta">
            Start a Project &gt;&gt;
          </a>
        </div>
        <div className="hero-image">
          <video 
            src={require('../landingVid.mp4')}
            autoPlay 
            loop 
            muted 
            playsInline
            className="team-photo"
          />
        </div>
      </div>
      <div className="hero-decoration hero-decoration-1">★</div>
      <div className="hero-decoration hero-decoration-2">—</div>
      <div className="hero-decoration hero-decoration-3">★</div>
      <div className="hero-decoration hero-decoration-4">—</div>
    </section>
  );
};

export default Hero; 